export default __webpack_public_path__ + "static/media/SUMUKHAs.8ea8f59b.png";